import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createywkzgrq4l4xy as create } from '../../../../../../kotlin-react/react/create.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function component1(_this__u8e3s4) {
  return _this__u8e3s4.state;
}
function create_0(_this__u8e3s4, state, key) {
  key = key === VOID ? null : key;
  return create(_this__u8e3s4, ($this$create) => {
    $this$create.state = state;
    var tmp0_safe_receiver = key;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$create.key = tmp0_safe_receiver;
    }
    return Unit_instance;
  });
}
function create$ref(p0) {
  return constructCallableReference((p0_0) => {
    var tmp0 = p0;
    return create_0(tmp0, p0_0);
  }, 1, 0, 245, VOID, [p0]);
}
//region block: exports
export {
  component1 as component12goe0t36bs1uq,
  create$ref as create$ref91n47pwsevvd,
};
//endregion

//# sourceMappingURL=LoadingPageFramePropsExtentions.mjs.map
